// Dynamic Diesels — Custom Tuning mobile scroll pager.
// Syncs the dot pager with the horizontal scroll position; tapping a dot
// smooth-scrolls to that card. Only relevant on mobile where the grid becomes
// a horizontal scroller; on desktop the dots stay hidden via CSS.

(function () {
  'use strict';

  function init() {
    document.querySelectorAll('.dd-tune').forEach((section) => {
      const scroller = section.querySelector('.dd-tune__grid');
      const dots = section.querySelectorAll('.dd-tune__dot');
      if (!scroller || !dots.length) return;
      const cards = scroller.querySelectorAll('.dd-tune-card');
      if (!cards.length) return;

      const setActive = (index) => {
        dots.forEach((dot, i) => {
          const on = i === index;
          dot.classList.toggle('is-active', on);
          if (on) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };

      const currentIndex = () => {
        const style = getComputedStyle(scroller);
        const gap = parseFloat(style.columnGap || style.gap) || 0;
        const step = cards[0].offsetWidth + gap;
        if (!step) return 0;
        return Math.min(cards.length - 1, Math.max(0, Math.round(scroller.scrollLeft / step)));
      };

      scroller.addEventListener('scroll', () => setActive(currentIndex()), { passive: true });

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const target = cards[index];
          if (!target) return;
          target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        });
      });

      setActive(currentIndex());
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
